<div
  class="left-drawer"
  [class.is-open]="isOpen"
  [class.can-animate]="canAnimate"
  [class.has-handle]="showOpenCloseHandle"
  [style.height]="height">
  @if (isOpen) {
    <ng-content></ng-content>
  }
</div>

@if (showOpenCloseHandle) {
  <div
    [style.left.px]="isOpen ? 400 : 0"
    [style.top.px]="handleTop"
    class="drawer-handle"
    fxLayout="column"
    fxLayoutAlign="center center"
    (click)="openCloseClick()">
    @if (isOpen) {
      <span>
        <i
          class="icon icon-caret_left"
          style="padding-top: 4px; font-size: 24px"></i>
      </span>
    } @else {
      <span class="material-icons icon">
        <i
          class="icon icon-caret_right"
          style="font-size: 24px"></i>
      </span>
    }
  </div>
}
